/**
 * Polls /api/oauth/gtm/setup-status while mounted.
 *
 * Backend writes the state machine atomically on orchestrator entry/exit
 * (PLAN_GTM_AUTO_INSTALL.md 2026-05-29 Gap #1):
 *   - status === null       : never started (or never authorized — check oauth_connected)
 *   - status === 'running'  : orchestrator in flight
 *   - status === 'succeeded': install complete (gtm_install_completed_at set)
 *   - status === 'failed'   : last run raised; error field has the message
 *
 * Same 1.5s cadence as the /me poller on OnboardingWebsitePage.
 */

import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api';

export interface GtmSetupStatus {
  completed: boolean;
  status: 'running' | 'succeeded' | 'failed' | null;
  error: string | null;
  started_at: string | null;
  oauth_connected: boolean;
  account_id: string | null;
  container_id: string | null;
  workspace_id: string | null;
  install_completed_at: string | null;
}

export function useGtmSetupStatus(options: { enabled?: boolean } = {}) {
  const { enabled = true } = options;
  return useQuery({
    queryKey: ['gtm', 'setup-status'],
    queryFn: () => apiRequest<GtmSetupStatus>('/oauth/gtm/setup-status'),
    enabled,
    refetchInterval: 1_500,
  });
}
